module.exports = __webpack_public_path__ + "static/media/kb2.f9e3d409.png";